import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import Header from '../../components/PageLayout/Header';
import Footer from '../../components/PageLayout/Footer';
import Alerts from '../../components/PageLayout/Alerts';
import Popups from '../../components/PageLayout/Popups';
import Sliders from '../../components/PageLayout/Sliders';
import ContentWrapper from '../../components/PageLayout/ContentWrapper';
import MainContent from '../../components/PageLayout/MainContent';
import SuccessNotification from './../../components/Generic/SuccessNotification';
export default function (props, context) {
    return React.createElement('div', { 'className': 'app-wrapper' }, React.createElement(Alerts, { 'className': 'app-alerts' }), React.createElement(Popups, {}), React.createElement(Sliders, { 'className': 'app-sliders' }), React.createElement(Header, {
        'componentClassName': this.props.headerClass,
        'component': this.props.pageHeader
    }), React.createElement(ContentWrapper, {
        'className': 'app-content-wrapper ' + this.props.contentWrapperCss,
        'contentClassName': this.props.contentWrapperInternalClass,
        'pageMenu': this.props.pageMenu,
        'setScrollContainer': this.setScrollContainer
    }, React.createElement(Header, {
        'componentClassName': 'app-content-header',
        'component': this.props.contentHeader
    }), React.createElement(MainContent, {
        'componentClassName': 'app-content-main',
        'component': this.props.content,
        'scrollContainer': this.scrollContainer
    }), React.createElement(Footer, {
        'componentClassName': 'app-content-footer',
        'component': this.props.contentFooter
    })), React.createElement(SuccessNotification, {}), React.createElement(Footer, {
        'componentClassName': 'app-footer',
        'component': this.props.pageFooter
    }), React.createElement('div', { 'className': 'portal-target' }));
}